import React from 'react';
import { FileTextIcon, ZapIcon, UsersIcon, LayersIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: UsersIcon,
  label: '11 a 18 años'
}, {
  icon: LayersIcon,
  label: 'Todos los casos'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 15 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
const stats = [{
  value: '+2.000',
  label: 'familias transformadas'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export function Hero() {
  return <header className="relative overflow-hidden border-b border-line bg-ink" data-id="element-127" data-mp="3d1sbczku5nu6">
      <div className="pointer-events-none absolute -right-40 -top-40 hidden h-[520px] w-[520px] rounded-full border border-line/70 lg:block" data-id="element-128" data-mp="382p4rap7j9k3" />
      <div className="pointer-events-none absolute -right-24 top-24 hidden h-[360px] w-[360px] rounded-full border border-line/50 lg:block" data-id="element-129" data-mp="3j9tymsm91cin" />

      <div className="relative mx-auto flex w-full max-w-3xl flex-col items-center px-5 pb-5 pt-3 text-center sm:px-8 lg:pb-14 lg:pt-8" data-id="element-130" data-mp="39acyeqprnqu2">
        <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-ivory sm:text-xs" data-id="element-131" data-mp="3e8efj63mtg2w">
          Órbita Digital™
        </p>

        <h1 className="mt-5 text-[26px] font-black leading-[1.15] tracking-tight text-accent sm:text-4xl lg:text-5xl" data-id="element-132" data-mp="30gq5d8cy11ok">
          ¿Sentís que tu hijo se está alejando de vos?
        </h1>

        <img src="https://cdn.magicpatterns.com/uploads/jCUqdCqKufd6mvDFePGgrf/1787859686973.png" alt="MegaPack Reconexión Familiar: caja del pack con sus guías y tarjetas" className="mt-7 w-full max-w-[220px] sm:max-w-[380px] lg:max-w-[460px]" loading="eager" data-id="element-133" data-mp="2qlepgmpstof8" />

        <p className="mt-7 max-w-xl text-[12px] font-semibold leading-relaxed text-ivory sm:text-lg" data-id="element-134" data-mp="2ll0f2y0q62e1">
          El sistema N°1 para padres de adolescentes en Argentina
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted sm:text-base" style={{
        fontSize: "12px"
      }} data-id="element-135" data-mp="nbl58stuaue5">
          Protocolos + tomos + bonos listos para usar. Sin buscar. Sin improvisar. Sin más
          conflictos.
        </p>

        <ul className="mt-6 flex w-full flex-nowrap items-center justify-center gap-1.5" data-id="element-136" data-mp="deq74b1haw0e">
          {chips.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex shrink-0 items-center gap-1 rounded-md border border-line bg-surface px-1.5 py-1 text-[7px] font-semibold leading-none text-ivory sm:px-2.5 sm:py-1.5 sm:text-[11px]" data-id="element-137" data-mp="161t0korasgjs">
              <Icon aria-hidden="true" className="h-2.5 w-2.5 shrink-0 text-accent sm:h-3.5 sm:w-3.5" data-id="element-138" data-mp="x1nvil9ktu8s" />
              <span className="whitespace-nowrap" data-id="element-139" data-mp="3lt774vhctzwd">{label}</span>
            </li>)}
        </ul>

        <CtaButton href="#planes" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-140" data-mp="3hqu0m4us9xyj">
          QUIERO MI MEGAPACK AHORA
        </CtaButton>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-141" data-mp="1xavz0ob4wg9d">
          {trust.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-2 text-sm text-muted" style={{
          fontSize: "8px"
        }} data-id="element-142" data-mp="269zj9vm1f1pg">
              <Icon aria-hidden="true" className="h-4 w-4 text-success" data-id="element-143" data-mp="2b0zcoqvy71n7" />
              {label}
            </li>)}
        </ul>
      </div>

      <div className="relative border-t border-line bg-surface/60" data-id="element-144" data-mp="2fzj3p5pef3mf">
        <dl className="mx-auto grid w-full max-w-content grid-cols-2 gap-y-6 px-5 pb-6 pt-3 text-center sm:px-8 lg:grid-cols-4" data-id="element-145" data-mp="2kxudjgfp1e4n">
          {stats.map(stat => <div key={stat.label} className="px-1" data-id="element-146" data-mp="2oyo1g9t4ysxj">
              <dt className="sr-only" data-id="element-147" data-mp="2tyino01yuuc9">{stat.label}</dt>
              <dd data-id="element-148" data-mp="umhdsbj22joc">
                <span className="flex items-center justify-center gap-1 text-2xl font-black tracking-tight text-ivory sm:text-3xl" style={{
              fontSize: "20px"
            }} data-id="element-149" data-mp="umzg9pwb9u4p">
                  {stat.value}
                  {stat.value === '4.9/5' && <StarIcon aria-hidden="true" className="h-5 w-5 fill-accent text-accent" data-id="element-150" data-mp="49t31sfpgurt" />}
                </span>
                <span className="mt-1 block text-sm text-muted" style={{
              fontSize: "12px"
            }} data-id="element-151" data-mp="3vhffa9ghq5ka">{stat.label}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}